import ChartLine from "components/chart/ChartLine";
import IndicadorDashboard from "components/chart/IndicadorDashboard";
import { ChartLineModel } from "model/chart/ChartLineModel";
import AnoManutencaoDashboard from "model/gestao/frotas/AnoManutencaoDashboard";
import ManutencaoDashboardTable from "model/gestao/frotas/ManutencaoDashboardTable";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable"
import { Row } from "primereact/row";
import { useEffect, useState } from "react"
import GestaoFrotasDashboardService from "service/gestao/frotas/GestaoFrotasDashboardService";


const gestaoFrotasDashboardService = new GestaoFrotasDashboardService();

function GestaoFrotasDashboard() {

    const [tableManutencao, setTableManutencao] = useState<ManutencaoDashboardTable | null>(null);
    const [chartManutencao, setChartManutencao] = useState<ChartLineModel>({ nameX: "", nameY: "", title: "", lines: [] });
    const [indicadorMaiorGasto, setIndicadorMaiorGasto] = useState<IndicadorDashboard>(new IndicadorDashboard("", "", 0));
    const [indicadorMaiorGastoAno, setIndicadorMaiorGastoAno] = useState<IndicadorDashboard>(new IndicadorDashboard("", "", 0));
    const [indicadorMaisManutencoes, setIndicadorMaisManutencoes] = useState<IndicadorDashboard>(new IndicadorDashboard("", "", 0));
    const [indicadorMaisManutencoesAno, setIndicadorMaisManutencoesAno] = useState<IndicadorDashboard>(new IndicadorDashboard("", "", 0));

    useEffect(() => {

        gestaoFrotasDashboardService.buscarTableManutencao()
            .then((tableManutencao) => setTableManutencao(tableManutencao))
            .catch((err) => console.error(err));

        gestaoFrotasDashboardService.buscarChartManutencao()
            .then((chartManutencao) => setChartManutencao(chartManutencao))
            .catch((err) => console.error(err));

        gestaoFrotasDashboardService.buscarIndicadorMaiorGasto()
            .then((indicadorMaiorGasto) => setIndicadorMaiorGasto(indicadorMaiorGasto))
            .catch((err) => console.error(err));

        gestaoFrotasDashboardService.buscarIndicadorMaiorGastoAno()
            .then((indicadorMaiorGastoAno) => setIndicadorMaiorGastoAno(indicadorMaiorGastoAno))
            .catch((err) => console.error(err));

        gestaoFrotasDashboardService.buscarIndicadorMaisManutencoes()
            .then((indicadorMaisManutencoes) => setIndicadorMaisManutencoes(indicadorMaisManutencoes))
            .catch((err) => console.error(err));

        gestaoFrotasDashboardService.buscarIndicadorMaisManutencoesAno()
            .then((indicadorMaisManutencoesAno) => setIndicadorMaisManutencoesAno(indicadorMaisManutencoesAno))
            .catch((err) => console.error(err));
    }, [])

    const footerTable = () => {
        return <ColumnGroup>
            <Row>
                <Column frozen footer="Total: " colSpan={1} footerStyle={{ textAlign: "right", fontSize: 14 }} />
                {tableManutencao?.anos.map((ano) => (
                    <Column footerStyle={{ fontSize: 14 }} footer={"R$" + (ano.valor || 0).toFixed(2).replace(".", ",")} colSpan={1} />
                ))}
                <Column footer={"R$" + (tableManutencao?.total || 0).toFixed(2).replace(".", ",")} footerStyle={{ fontSize: 14 }} colSpan={1} />
            </Row>
        </ColumnGroup>
    }

    const indicador = (indicador: IndicadorDashboard, imagem: string, valor: string) => {
        return (
            <div style={{ display: "flex", width: "23%", minHeight: 125, padding: 10, boxSizing: "border-box", borderRadius: 10, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                <img src={imagem} width={75} alt="" />
                <div style={{ display: "flex", flexDirection: "column", marginLeft: 15 }} >
                    <span style={{ fontSize: 18, fontWeight: 500, color: "#777" }}>{indicador.titulo}</span>

                    <div style={{ display: "flex", flexDirection: "column", marginLeft: 15 }}>

                        <span style={{ fontSize: 20, fontWeight: 700 }}>{valor}</span>
                        <span style={{ fontSize: 14, fontWeight: 500 }}>{indicador.alvo}</span>

                    </div>
                </div>

            </div>
        )
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 50 }}>
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                {indicador(indicadorMaiorGasto, "/imagens/indicador-dinheiro.png", "R$" + indicadorMaiorGasto.valor.toFixed(2).replace(".", ","))}
                {indicador(indicadorMaiorGastoAno, "/imagens/indicador-dinheiro.png", "R$" + indicadorMaiorGastoAno.valor.toFixed(2).replace(".", ","))}
                {indicador(indicadorMaisManutencoes, "/imagens/indicador-manutencao.png", indicadorMaisManutencoes.valor + " manutenções")}
                {indicador(indicadorMaisManutencoesAno, "/imagens/indicador-manutencao.png", indicadorMaisManutencoesAno.valor + " manutenções")}
            </div>
            <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                <div style={{ width: "48%", padding: 20, boxSizing: "border-box", borderRadius: 10, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                    <p style={{ fontSize: 18, fontWeight: 500, color: "#777" }} >Gastos por veículo</p>
                    <DataTable
                        value={tableManutencao?.veiculos}
                        footerColumnGroup={footerTable()}
                        style={{ width: "100%", minHeight: 400, }}
                        scrollable
                        emptyMessage="Nenhum registro encontrado"
                    >
                        <Column field="modelo" header="Modelo" style={{ fontSize: 14 }} frozen></Column>
                        {tableManutencao?.anos.map((ano) => (
                            <Column
                                style={{ width: "125px", fontSize: 14 }}
                                field={"ano" + ano} header={ano.ano}
                                body={(rowData) => "R$" + (rowData.anos.find((anoVeiculo: AnoManutencaoDashboard) => anoVeiculo.ano == ano.ano)?.valor || 0).toFixed(2).replace(".", ",")}
                            />
                        ))}
                        <Column
                            style={{ width: "150px", fontWeight: 700, fontSize: 14 }}
                            field="total" header="Total"
                            body={(rowData) => "R$" + (rowData.total).toFixed(2).replace(".", ",")}
                        />
                    </DataTable>
                </div>
                <div style={{ width: "48%", padding: 20, boxSizing: "border-box", borderRadius: 10, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                    <p style={{ fontSize: 18, fontWeight: 500, color: "#777" }} >{chartManutencao.title}</p>
                    <ChartLine
                        showTitle={false}
                        width={"100%"}
                        height={200}
                        data={chartManutencao}
                        interpolation="natural"
                    />
                </div>
            </div>
        </div>

    )
}

export default GestaoFrotasDashboard